import type { PassKind } from '@/music/performance';

/**
 * What each chorus is called on the Choruses panel's jump row. Under the
 * head/solos/head itinerary the passes have jobs, so they say so: the head
 * (a written repeat makes a second "Head 2"), the solo choruses by number,
 * and the head out as "Out". Anything else (plain ×N, a written-out ending)
 * is just numbered. A kind list that does not match the pass count is not
 * trusted: the numbers are always true.
 */
export function chorusLabels(total: number, kinds?: readonly PassKind[]): string[] {
  const count = Math.max(0, Math.floor(total));
  const numbered = Array.from({ length: count }, (_, i) => String(i + 1));
  if (!kinds || kinds.length !== count || kinds.every((kind) => kind === 'written')) {
    return numbered;
  }
  let heads = 0;
  let solos = 0;
  return kinds.map((kind, i) => {
    if (kind === 'head') return ++heads === 1 ? 'Head' : `Head ${heads}`;
    if (kind === 'solo') return String(++solos);
    if (kind === 'head-out') return 'Out';
    return numbered[i];
  });
}
